@if (mainField && isVisible) {
<field-template
  [tooltip]="tooltip"
  [horizontallyCollapsed]="shouldCollapseHorizontally"
  [class.invoiceAddresses]="isIdInvoiceAddresses"
  [class.quoted-product-ctrl]="
    mainField.attributes.display_type === 'quotedProduct'
  "
>
  <field-label [field]="mainField" mainLabel></field-label>
  <div [class.multiple]="fields && fields.length > 0" class="d-flex-col">
    @if (mainField.attributes.message) {
    <div class="message-container">
      {{ mainField.attributes.message }}
    </div>
    } @for (field of fields; track field) {
    <field-control
      id="{{ field?.name }}"
      [field]="field"
      (change)="onFieldControlChange(field)"
      (onChangeValue)="onChangeValue(field)"
      [changeServiceToUniversal]="changeServiceToUniversal"
    ></field-control>
    }
  </div>
  <ng-content select="[additional]" additional></ng-content>
  <ng-container errors>
    <field-errors [controls]="controls"></field-errors>
  </ng-container>
</field-template>
}
